import { render, staticRenderFns } from "./LawStatisticList.vue?vue&type=template&id=590ec0d3&scoped=true"
import script from "./LawStatisticList.vue?vue&type=script&lang=js"
export * from "./LawStatisticList.vue?vue&type=script&lang=js"
import style0 from "./LawStatisticList.vue?vue&type=style&index=0&id=590ec0d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590ec0d3",
  null
  
)

export default component.exports